import {graphql} from 'gatsby'
import {RelatedTilesFragment} from 'gatsby-graphql-types-generated'

import {Box} from 'src/components/Box'
import RelatedContent from 'src/components/RelatedContent'

export const query = graphql`
  fragment RelatedTiles on ContentfulArticleTile {
    id
    relatedTiles {
      ...RelatedArticle
    }
  }
`

interface Props {
  relatedTiles: RelatedTilesFragment['relatedTiles']
}

const RelatedTiles = ({relatedTiles}: Props) => {
  if (!relatedTiles) {
    return null
  }
  return (
    <Box mt="5">
      <RelatedContent articles={relatedTiles} />
    </Box>
  )
}

export default RelatedTiles
